export default __webpack_public_path__ + "static/media/image2.7a5f0b16.png";